import { type EditorState, Selection, type Transaction } from "prosemirror-state";

export const focusPosition = (state: EditorState, position: number): Transaction => {
	const tr = state.tr;
	const $pos = tr.doc.resolve(position);
	return tr.setSelection(Selection.near($pos));
};
